export default __webpack_public_path__ + "static/media/pexels-quintingellar-2199293.7779e248.jpg";